import React from 'react';
import { Provider as ReakitProvider } from 'reakit';

interface UIProviderProps {
    children: React.ReactNode;
}

// Composes all providers necessary for UI components inside this library
export function UIProvider({ children }: UIProviderProps) {
    return <ReakitProvider>{children}</ReakitProvider>;
}
